import { PriceBookItemTypes } from "@constants/choices"

import { PriceBookItemCardProps } from "./PriceBookItemCard.types"
import DiscountCard from "./subcards/DiscountCard"
import LaborCard from "./subcards/LaborCard"
import OtherCard from "./subcards/OtherCard"
import ProductCard from "./subcards/ProductCard"
import TaxRateCard from "./subcards/TaxRateCard"

// Each pricebook item type renders a dedicated subcard. The names differ from the legacy
// pricebook type names (service → Labor, part → Product) as we migrate towards the new ones.
const SUBCARD_BY_TYPE: Record<number, (props: PriceBookItemCardProps) => JSX.Element> = {
    [PriceBookItemTypes.service]: LaborCard,
    [PriceBookItemTypes.part]: ProductCard,
    [PriceBookItemTypes.other]: OtherCard,
    [PriceBookItemTypes.discount]: DiscountCard,
    [PriceBookItemTypes.tax]: TaxRateCard,
}

export default function PriceBookItemCard(props: PriceBookItemCardProps) {
    const Subcard = SUBCARD_BY_TYPE[props.pricebookItem.pricebook_item_type]

    return <Subcard {...props} />
}
